import React, { FunctionComponent, ReactChild, ReactNode } from 'react'
import { TransitionGroup, Transition as ReactTransition, TransitionStatus } from 'react-transition-group'
import clsx from 'clsx'

import styles from './style.module.css'

export enum PageTransitionDirection {
  Forward,
  Backward,
}
interface Props {
  location: string
  children: ReactChild | ReactNode
  direction?: PageTransitionDirection
  removeTransition?: boolean
}
const TIMEOUT: number = 200

const getStyling = (
  direction
): {
  [x: string]: string
} => {
  const directionModifier = direction === PageTransitionDirection.Backward && styles.backwards
  return {
    entering: clsx(styles.entering, directionModifier),
    entered: clsx(styles.entered, directionModifier),
    exiting: clsx(styles.exiting, directionModifier),
    exited: clsx(styles.exited, directionModifier),
  }
}

export const TransitionContext = React.createContext<TransitionStatus>('entering')

export const PageTransition: FunctionComponent<Props> = ({ children, removeTransition = false, location, direction = PageTransitionDirection.Forward }) => {
  const nodeRef = React.useRef(null)
  const stylings = getStyling(direction)
  if (removeTransition) {
    return <div className={styles.childrenContainer}>{children}</div>
  }
  return (
    <TransitionGroup className={styles.wrapper}>
      <ReactTransition
        nodeRef={nodeRef}
        key={location}
        timeout={{
          enter: TIMEOUT * 2,
          exit: TIMEOUT,
        }}
      >
        {(status) => (
          <TransitionContext.Provider value={status}>
            <div ref={nodeRef} className={stylings[status]}>
              <div className={styles.childrenContainer}>{children}</div>
            </div>
          </TransitionContext.Provider>
        )}
      </ReactTransition>
    </TransitionGroup>
  )
}
